import React from 'react'
import { lazyload } from 'react-lazyload';
import Thumbnail from '../Thumbnail';

class ThumbnailGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images: props.thumbs || [],
      max: props.max || 5,
      columns: props.columns || 5,
    }
  }

  renderThumbnails() {
    const hasRemainder = this.remainder();
    const thumbs = this.state.images.slice(0, this.state.max).map((image, index, slices) => {

      // Disable remainder if false or not last thumb
      const remainder = (index == slices.length - 1 && hasRemainder) ? hasRemainder : false;
      const {src, link, alt} = image;

      return (
        <div className="afd-thumbnail-grid__thumb" key={index}>
          <Thumbnail src={src} link={link} alt={alt} remainder={remainder}/>
        </div>
      )
    });

    return thumbs;
  }

  remainder() {
    const remainder = this.state.images.length - this.state.max;

    return remainder > 0 ? remainder : false;
  }

  render() {
    const thumbs = this.renderThumbnails();

    return (
      <div className="afd-thumbnail-grid">
        {thumbs}
      </div>
    )
  }
}

export default ThumbnailGrid;
